import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import WidgetRouter from './WidgetRouter';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  // Déterminer si nous sommes dans l'environnement iframe ou dans l'app de développement
  const isIframe = window.location.pathname !== '/';

  root.render(
      <React.StrictMode>
        {isIframe ? <WidgetRouter /> : <App />}
      </React.StrictMode>,
  );
}
